var chat = "https://shopfront-cdn.tekoapis.com/static/aaf120a4ce138b4c.svg";

export { chat as default };
